// Copyright 2026, Imprivata, Inc.  All rights reserved.

export const TRANSLATION_ROOT = 'apps.profiles';
export const APP_PROFILES_FEATURE_FLAG = 'EAMC_APG_SSO_ENABLED' as const;
